import type { SVGProps } from 'react'
const SvgUndo = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="1em" viewBox="0 0 16 16" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={16}
      id="undo_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={16}
      x={0}
      y={0}
    >
      <path d="M0 0h16v16H0z" fill="#D9D9D9" />
    </mask>
    <g mask="url(#undo_svg__a)">
      <path
        d="M4.715 12.802v-1.516h4.769q1.002 0 1.735-.65.733-.649.733-1.612t-.733-1.615a2.53 2.53 0 0 0-1.735-.65H5.415l1.65 1.65-1.06 1.06L2.53 6l3.473-3.469 1.06 1.061-1.649 1.65h4.069q1.64 0 2.813 1.088 1.172 1.088 1.172 2.69t-1.172 2.692-2.813 1.09z"
        fill="#DC4405"
      />
    </g>
  </svg>
)
export default SvgUndo
